import { FormattedMessage } from 'react-intl';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Badge } from '@sorare/core/src/atoms/ui/Badge';
import { fantasy } from '@sorare/core/src/lib/glossary';

import { useRedDotNotification } from 'hooks/useRedDotNotification';

type Props = {
  ongoingFixtureStartDate?: Date;
  sport: Sport;
  discoverCompetitionsUrl: string;
};
export const DiscoverCompetitionsButton = ({
  ongoingFixtureStartDate,
  sport,
  discoverCompetitionsUrl,
}: Props) => {
  const [shouldDisplay, update] = useRedDotNotification(
    ongoingFixtureStartDate,
    sport
  );

  return (
    <div>
      <Badge variant="dot" invisible={!shouldDisplay('enterATeam')}>
        <Button
          color="tertiary"
          size="medium"
          to={discoverCompetitionsUrl}
          // Not using onClick here as it can have some race condition with the regular navigation
          onPointerDown={() => {
            update('enterATeam');
          }}
        >
          <FormattedMessage {...fantasy.discoverNewCompetitions} />
        </Button>
      </Badge>
    </div>
  );
};
